import { useFrame } from '@react-three/fiber'
import { RigidBody } from '@react-three/rapier'
import { useEffect, useRef } from 'react'
import * as THREE from 'three'

export default function ShapeBlender()
{
    const twister = useRef()

    // useEffect(()=>{console.log()})

    useFrame((state)=>{
        const time = state.clock.elapsedTime * 5
        const speed = 1

        const eulerRotation = new THREE.Euler(0,time * speed,0)
        const quaternionRotation = new THREE.Quaternion()
        quaternionRotation.setFromEuler(eulerRotation)
        twister.current.setNextKinematicRotation(quaternionRotation)
        

        const angle = - state.clock.elapsedTime * speed
        const radius = 3
        const x = Math.sin(angle) * radius
        const z = Math.cos(angle) * radius
        twister.current.setNextKinematicTranslation({x:x, y:-0.8, z:z})
    })

    const collisionEnter = () => {
        console.log('collision of the blender')
    }

    return <>
        <RigidBody 
            ref={twister}
            position={[0,-0.8,0]}
            friction={0}
            type='kinematicPosition'
            
            rotation={[0,0,0]}
        >
            <mesh castShadow receiveShadow >
                <boxGeometry args={[0.4, 0.4, 3]} />
                <meshStandardMaterial color={'red'} />
            </mesh>
        </RigidBody>
    </>
}